/**
 * Maison Kamybloom — Luxury Cart & Drawer Engine
 * Guarantees that Add to Cart always places products into the cart drawer,
 * providing immediate, elegant feedback, free shipping calculations,
 * and seamless European luxury checkout.
 */

(function() {
  'use strict';

  // Catalog registry for Kamybloom's ritual products
  const LUXURY_CATALOG = {
    48015124463754: {
      id: 48015124463754,
      title: "Shampoing Kératine, Vanille & Monoï",
      price: 1999,
      formattedPrice: "19,99 €",
      image: "//cdn.shopify.com/s/files/1/0726/9633/2426/files/e58f5f15-6c8c-478e-b1c1-28ae26ad79e6_591d135e-7728-4695-86ca-02bf8b3b3255.jpg?v=1776013540&width=250",
      url: "/products/shampoing-keratine-vanille-monoi",
      step: "01 — NETTOYER",
      complementaryId: 48015148744842
    },
    48015148744842: {
      id: 48015148744842,
      title: "Masque Capillaire Kératine, Vanille & Monoï",
      price: 1999,
      formattedPrice: "19,99 €",
      image: "//cdn.shopify.com/s/files/1/0726/9633/2426/files/IMG_1997.jpg?v=1776012426&width=250",
      url: "/products/masque-capillaire-keratine-vanille-monoi",
      step: "02 — RÉPARER",
      complementaryId: 48015124463754
    },
    48015156117642: {
      id: 48015156117642,
      title: "Duo Shampoing & Masque (Le Rituel Signature)",
      price: 3899,
      formattedPrice: "38,99 €",
      image: "//cdn.shopify.com/s/files/1/0726/9633/2426/files/IMG_1942.jpg?v=1776012425&width=250",
      url: "/products/duo-shampoing-masque",
      step: "RITUEL COMPLET",
      complementaryId: null
    }
  };

  const STORAGE_KEY = 'kamybloom_luxury_cart';
  const FREE_SHIPPING_THRESHOLD = 4000; // 40.00 EUR

  const PAYMENT_ICONS_SVG_HTML = `
    <span class="payment-method-icon" title="Visa">
      <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" fill="none" aria-labelledby="pi-visa-c"><title id="pi-visa-c">Visa</title><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"></rect><path d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z" fill="#142FBD" style="fill:#142FBD;fill:color(display-p3 0.0784 0.1843 0.7412);fill-opacity:1;"></path><path d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z" fill="#1532CB" style="fill:#1532CB;fill:color(display-p3 0.0824 0.1961 0.7961);fill-opacity:1;"></path><path d="M29.5944 10.2167H29.2778C28.8556 11.2722 28.5389 11.8 28.2222 13.3833H30.2278C29.9111 11.8 29.9111 11.0611 29.5944 10.2167V10.2167ZM32.6556 16.4444H30.8611C30.7556 16.4444 30.7556 16.4444 30.65 16.3389L30.4389 15.3889L30.3333 15.1778H27.8C27.6944 15.1778 27.5889 15.1778 27.5889 15.3889L27.2722 16.3389C27.2722 16.4444 27.1667 16.4444 27.1667 16.4444H24.95L25.1611 15.9167L28.2222 8.73889C28.2222 8.21111 28.5389 8 29.0667 8H30.65C30.7556 8 30.8611 8 30.8611 8.21111L32.3389 15.0722C32.4444 15.4944 32.55 15.8111 32.55 16.2333C32.6556 16.3389 32.6556 16.3389 32.6556 16.4444V16.4444ZM18.5111 16.1278L18.9333 14.2278C19.0389 14.2278 19.1444 14.3333 19.1444 14.3333C19.8833 14.65 20.6222 14.8611 21.3611 14.7556C21.5722 14.7556 21.8889 14.65 22.1 14.5444C22.6278 14.3333 22.6278 13.8056 22.2056 13.3833C21.9944 13.1722 21.6778 13.0667 21.3611 12.8556C20.9389 12.6444 20.5167 12.4333 20.2 12.1167C18.9333 11.0611 19.3556 9.58333 20.0944 8.84444C20.7278 8.42222 21.0444 8 21.8889 8C23.1556 8 24.5278 8 25.1611 8.21111H25.2667C25.1611 8.84444 25.0556 9.37222 24.8444 10.0056C24.3167 9.79444 23.7889 9.58333 23.2611 9.58333C22.9444 9.58333 22.6278 9.58333 22.3111 9.68889C22.1 9.68889 21.9944 9.79444 21.8889 9.9C21.6778 10.1111 21.6778 10.4278 21.8889 10.6389L22.4167 11.0611C22.8389 11.2722 23.2611 11.4833 23.5778 11.6944C24.1056 12.0111 24.6333 12.5389 24.7389 13.1722C24.95 14.1222 24.6333 14.9667 23.7889 15.6C23.2611 16.0222 23.05 16.2333 22.3111 16.2333C20.8333 16.2333 19.6722 16.3389 18.7222 16.0222C18.6167 16.2333 18.6167 16.2333 18.5111 16.1278V16.1278ZM14.8167 16.4444C14.9222 15.7056 14.9222 15.7056 15.0278 15.3889C15.5556 13.0667 16.0833 10.6389 16.5056 8.31667C16.6111 8.10556 16.6111 8 16.8222 8H18.7222C18.5111 9.26667 18.3 10.2167 17.9833 11.3778C17.6667 12.9611 17.35 14.5444 16.9278 16.1278C16.9278 16.3389 16.8222 16.3389 16.6111 16.3389L14.8167 16.4444ZM5 8.21111C5 8.10556 5.21111 8 5.31667 8H8.90556C9.43333 8 9.85556 8.31667 9.96111 8.84444L10.9111 13.4889C10.9111 13.5944 10.9111 13.5944 11.0167 13.7C11.0167 13.5944 11.1222 13.5944 11.1222 13.5944L13.3389 8.21111C13.2333 8.10556 13.3389 8 13.4444 8H15.6611C15.6611 8.10556 15.6611 8.10556 15.5556 8.21111L12.2833 15.9167C12.1778 16.1278 12.1778 16.2333 12.0722 16.3389C11.9667 16.4444 11.7556 16.3389 11.5444 16.3389H9.96111C9.85556 16.3389 9.75 16.3389 9.75 16.1278L8.06111 9.58333C7.85 9.37222 7.53333 9.05556 7.11111 8.95C6.47778 8.63333 5.31667 8.42222 5.10556 8.42222L5 8.21111Z" fill="white" style="fill:white;fill-opacity:1;"></path></svg>
    </span>
    <span class="payment-method-icon" title="Mastercard">
      <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" fill="none" aria-labelledby="pi-master-c"><title id="pi-master-c">Mastercard</title><rect x=".5" y=".5" width="37" height="23" rx="2.5" stroke="#000" stroke-opacity=".07" fill="none"></rect><path d="M35 0H3C1.3 0 0 1.3 0 3V21C0 22.7 1.4 24 3 24H35C36.7 24 38 22.7 38 21V3C38 1.3 36.6 0 35 0Z" fill="#1C1C1C" style="fill:#1C1C1C;fill:color(display-p3 0.1098 0.1098 0.1098);fill-opacity:1;"></path><path d="M35 1C36.1 1 37 1.9 37 3V21C37 22.1 36.1 23 35 23H3C1.9 23 1 22.1 1 21V3C1 1.9 1.9 1 3 1H35Z" fill="#232323" style="fill:#232323;fill:color(display-p3 0.1373 0.1373 0.1373);fill-opacity:1;"></path><path d="M14.6364 19.2727C18.8538 19.2727 22.2727 15.8538 22.2727 11.6364C22.2727 7.41892 18.8538 4 14.6364 4C10.4189 4 7 7.41892 7 11.6364C7 15.8538 10.4189 19.2727 14.6364 19.2727Z" fill="#EB001B" style="fill:#EB001B;fill:color(display-p3 0.9216 0.0000 0.1059);fill-opacity:1;"></path><path d="M23.3637 19.2727C27.5811 19.2727 31 15.8538 31 11.6364C31 7.41892 27.5811 4 23.3637 4C19.1462 4 15.7273 7.41892 15.7273 11.6364C15.7273 15.8538 19.1462 19.2727 23.3637 19.2727Z" fill="#F79E1B" style="fill:#F79E1B;fill:color(display-p3 0.9686 0.6196 0.1059);fill-opacity:1;"></path><path d="M22.2727 11.6362C22.2727 9.01797 20.9637 6.72706 19 5.41797C17.0364 6.83615 15.7273 9.12706 15.7273 11.6362C15.7273 14.1452 17.0364 16.5452 19 17.8543C20.9637 16.5452 22.2727 14.2543 22.2727 11.6362Z" fill="#FF5F00" style="fill:#FF5F00;fill:color(display-p3 1.0000 0.3725 0.0000);fill-opacity:1;"></path></svg>
    </span>
    <span class="payment-method-icon" title="Apple Pay">
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg" role="img" x="0" y="0" width="38" height="24" viewBox="0 0 165.521 105.965" xml:space="preserve" aria-labelledby="pi-apple_pay-c"><title id="pi-apple_pay-c">Apple Pay</title><path fill="#000" d="M150.698 0H14.823c-.566 0-1.133 0-1.698.003-.477.004-.953.009-1.43.022-1.039.028-2.087.09-3.113.274a10.51 10.51 0 0 0-2.958.975 9.932 9.932 0 0 0-4.35 4.35 10.463 10.463 0 0 0-.975 2.96C.113 9.611.052 10.658.024 11.696a70.22 70.22 0 0 0-.022 1.43C0 13.69 0 14.256 0 14.823v76.318c0 .567 0 1.132.002 1.699.003.476.009.953.022 1.43.028 1.036.09 2.084.275 3.11a10.46 10.46 0 0 0 .974 2.96 9.897 9.897 0 0 0 1.83 2.52 9.874 9.874 0 0 0 2.52 1.83c.947.483 1.917.79 2.96.977 1.025.183 2.073.245 3.112.273.477.011.953.017 1.43.02.565.004 1.132.004 1.698.004h135.875c.565 0 1.132 0 1.697-.004.476-.002.952-.009 1.431-.02 1.037-.028 2.085-.09 3.113-.273a10.478 10.478 0 0 0 2.958-.977 9.955 9.955 0 0 0 4.35-4.35c.483-.947.789-1.917.974-2.96.186-1.026.246-2.074.274-3.11.013-.477.02-.954.022-1.43.004-.567.004-1.132.004-1.699V14.824c0-.567 0-1.133-.004-1.699a63.067 63.067 0 0 0-.022-1.429c-.028-1.038-.088-2.085-.274-3.112a10.4 10.4 0 0 0-.974-2.96 9.94 9.94 0 0 0-4.35-4.35A10.52 10.52 0 0 0 156.939.3c-1.028-.185-2.076-.246-3.113-.274a71.417 71.417 0 0 0-1.431-.022C151.83 0 151.263 0 150.698 0z"></path><path fill="#FFF" d="M150.698 3.532l1.672.003c.452.003.905.008 1.36.02.793.022 1.719.065 2.583.22.75.135 1.38.34 1.984.648a6.392 6.392 0 0 1 2.804 2.807c.306.6.51 1.226.645 1.983.154.854.197 1.783.218 2.58.013.45.019.9.02 1.36.005.557.005 1.113.005 1.671v76.318c0 .558 0 1.114-.004 1.682-.002.45-.008.9-.02 1.35-.022.796-.065 1.725-.221 2.589a6.855 6.855 0 0 1-.645 1.975 6.397 6.397 0 0 1-2.808 2.807c-.6.306-1.228.511-1.971.645-.881.157-1.847.2-2.574.22-.457.01-.912.017-1.379.019-.555.004-1.113.004-1.669.004H14.801c-.55 0-1.1 0-1.66-.004a74.993 74.993 0 0 1-1.35-.018c-.744-.02-1.71-.064-2.584-.22a6.938 6.938 0 0 1-1.986-.65 6.337 6.337 0 0 1-1.622-1.18 6.355 6.355 0 0 1-1.178-1.623 6.935 6.935 0 0 1-.646-1.985c-.156-.863-.2-1.788-.22-2.578a66.088 66.088 0 0 1-.02-1.355l-.003-1.327V14.474l.002-1.325a66.7 66.7 0 0 1 .02-1.357c.022-.792.065-1.717.222-2.587a6.924 6.924 0 0 1 .646-1.981c.304-.598.7-1.144 1.18-1.623a6.386 6.386 0 0 1 1.624-1.18 6.96 6.96 0 0 1 1.98-.646c.865-.155 1.792-.198 2.586-.22.452-.012.905-.017 1.354-.02l1.677-.003h135.875"></path><g><g><path fill="#000" d="M43.508 35.77c1.404-1.755 2.356-4.112 2.105-6.52-2.054.102-4.56 1.355-6.012 3.112-1.303 1.504-2.456 3.959-2.156 6.266 2.306.2 4.61-1.152 6.063-2.858"></path><path fill="#000" d="M45.587 39.079c-3.35-.2-6.196 1.9-7.795 1.9-1.6 0-4.049-1.8-6.698-1.751-3.447.05-6.645 2-8.395 5.1-3.598 6.2-.95 15.4 2.55 20.45 1.699 2.5 3.747 5.25 6.445 5.151 2.55-.1 3.549-1.65 6.647-1.65 3.097 0 3.997 1.65 6.696 1.6 2.798-.05 4.548-2.5 6.247-5 1.95-2.85 2.747-5.6 2.797-5.75-.05-.05-5.396-2.101-5.446-8.251-.05-5.15 4.198-7.6 4.398-7.751-2.399-3.548-6.147-3.948-7.447-4.048"></path></g><g><path fill="#000" d="M78.973 32.11c7.278 0 12.347 5.017 12.347 12.321 0 7.33-5.173 12.373-12.529 12.373h-8.058V69.62h-5.822V32.11h14.062zm-8.24 19.807h6.68c5.07 0 7.954-2.729 7.954-7.46 0-4.73-2.885-7.434-7.928-7.434h-6.706v14.894z"></path><path fill="#000" d="M92.764 61.847c0-4.809 3.665-7.564 10.423-7.98l7.252-.442v-2.08c0-3.04-2.001-4.704-5.562-4.704-2.938 0-5.07 1.507-5.51 3.82h-5.252c.157-4.86 4.731-8.395 10.918-8.395 6.654 0 10.995 3.483 10.995 8.89v18.663h-5.38v-4.497h-.13c-1.534 2.937-4.914 4.782-8.579 4.782-5.406 0-9.175-3.222-9.175-8.057zm17.675-2.417v-2.106l-6.472.416c-3.64.234-5.536 1.585-5.536 3.95 0 2.288 1.975 3.77 5.068 3.77 3.95 0 6.94-2.522 6.94-6.03z"></path><path fill="#000" d="M120.975 79.652v-4.496c.364.051 1.247.103 1.715.103 2.573 0 4.029-1.09 4.913-3.899l.52-1.663-9.852-27.293h6.082l6.863 22.146h.13l6.862-22.146h5.927l-10.216 28.67c-2.34 6.577-5.017 8.735-10.683 8.735-.442 0-1.872-.052-2.261-.157z"></path></g></g></svg>
    </span>
    <span class="payment-method-icon" title="Shop Pay">
      <svg xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 38 24" width="38" height="24" aria-labelledby="pi-shopify_pay-c"><title id="pi-shopify_pay-c">Shop Pay</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z" fill="#000"></path><path d="M35.889 0C37.05 0 38 .982 38 2.182v19.636c0 1.2-.95 2.182-2.111 2.182H2.11C.95 24 0 23.018 0 21.818V2.182C0 .982.95 0 2.111 0H35.89z" fill="#5A31F4"></path><path d="M9.35 11.368c-1.017-.223-1.47-.31-1.47-.705 0-.372.306-.558.92-.558.54 0 .934.238 1.225.704a.079.079 0 00.104.03l1.146-.584a.082.082 0 00.032-.114c-.475-.831-1.353-1.286-2.51-1.286-1.52 0-2.464.755-2.464 1.956 0 1.275 1.15 1.597 2.17 1.82 1.02.222 1.474.31 1.474.705 0 .396-.332.582-.993.582-.612 0-1.065-.282-1.34-.83a.08.08 0 00-.107-.035l-1.143.57a.083.083 0 00-.036.111c.454.92 1.384 1.437 2.627 1.437 1.583 0 2.539-.742 2.539-1.98s-1.155-1.598-2.173-1.82v-.003zM15.49 8.855c-.65 0-1.224.232-1.636.646a.04.04 0 01-.069-.03v-2.64a.08.08 0 00-.08-.081H12.27a.08.08 0 00-.08.082v8.194a.08.08 0 00.08.082h1.433a.08.08 0 00.081-.082v-3.594c0-.695.528-1.227 1.239-1.227.71 0 1.226.521 1.226 1.227v3.594a.08.08 0 00.081.082h1.433a.08.08 0 00.081-.082v-3.594c0-1.51-.981-2.577-2.355-2.577zM20.753 8.62c-.778 0-1.507.24-2.03.588a.082.082 0 00-.027.109l.632 1.088a.08.08 0 00.11.03 2.5 2.5 0 011.318-.366c1.25 0 2.17.891 2.17 2.068 0 1.003-.736 1.745-1.669 1.745-.76 0-1.288-.446-1.288-1.077 0-.361.152-.657.548-.866a.08.08 0 00.032-.113l-.596-1.018a.08.08 0 00-.098-.035c-.799.299-1.359 1.018-1.359 1.984 0 1.46 1.152 2.55 2.76 2.55 1.877 0 3.227-1.313 3.227-3.195 0-2.018-1.57-3.492-3.73-3.492zM28.675 8.843c-.724 0-1.373.27-1.845.746-.026.027-.069.007-.069-.029v-.572a.08.08 0 00-.08-.082h-1.397a.08.08 0 00-.08.082v8.182a.08.08 0 00.08.081h1.433a.08.08 0 00.081-.081v-2.683c0-.036.043-.054.069-.03a2.6 2.6 0 001.808.7c1.682 0 2.993-1.373 2.993-3.157s-1.313-3.157-2.993-3.157zm-.271 4.929c-.956 0-1.681-.768-1.681-1.783s.723-1.783 1.681-1.783c.958 0 1.68.755 1.68 1.783 0 1.027-.713 1.783-1.681 1.783h.001z" fill="#fff"></path></svg>
    </span>
    <span class="payment-method-icon" title="PayPal">
      <svg viewBox="0 0 38 24" xmlns="http://www.w3.org/2000/svg" width="38" height="24" role="img" aria-labelledby="pi-paypal-c"><title id="pi-paypal-c">PayPal</title><path opacity=".07" d="M35 0H3C1.3 0 0 1.3 0 3v18c0 1.7 1.4 3 3 3h32c1.7 0 3-1.3 3-3V3c0-1.7-1.4-3-3-3z"></path><path fill="#fff" d="M35 1c1.1 0 2 .9 2 2v18c0 1.1-.9 2-2 2H3c-1.1 0-2-.9-2-2V3c0-1.1.9-2 2-2h32"></path><path fill="#003087" d="M23.9 8.3c.2-1 0-1.7-.6-2.3-.6-.7-1.7-1-3.1-1h-4.1c-.3 0-.5.2-.6.5L14 15.6c0 .2.1.4.3.4H17l.4-3.4 1.8-2.2 4.7-2.1z"></path><path fill="#3086C8" d="M23.9 8.3l-.2.2c-.5 2.8-2.2 3.8-4.6 3.8H18c-.3 0-.5.2-.6.5l-.6 3.9-.2 1c0 .2.1.4.3.4H19c.3 0 .5-.2.5-.4v-.1l.4-2.4v-.1c0-.2.3-.4.5-.4h.3c2.1 0 3.7-.8 4.1-3.2.2-1 .1-1.8-.4-2.4-.1-.5-.3-.7-.5-.8z"></path><path fill="#012169" d="M23.3 8.1c-.1-.1-.2-.1-.3-.1-.1 0-.2 0-.3-.1-.3-.1-.7-.1-1.1-.1h-3c-.1 0-.2 0-.2.1-.2.1-.3.2-.3.4l-.7 4.4v.1c0-.3.3-.5.6-.5h1.3c2.5 0 4.1-1 4.6-3.8v-.2c-.1-.1-.3-.2-.5-.2h-.1z"></path></svg>
    </span>
  `;

  function getLocalCart() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  function saveLocalCart(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {
      console.warn('LocalStorage save error', e);
    }
  }

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function updateHeaderCartBubble(count) {
    count = Number(count) || 0;
    const bubbles = document.querySelectorAll('.cart-bubble');
    bubbles.forEach(b => {
      b.classList.toggle('visually-hidden', count === 0);
      const countEl = b.querySelector('.cart-bubble__text-count, [data-testid="cart-bubble"]');
      if (countEl) {
        countEl.textContent = count > 0 ? (count < 100 ? String(count) : '99+') : '';
        countEl.classList.toggle('hidden', count === 0);
      }
    });

    const oldBubbles = document.querySelectorAll('.cart-icon-bubble, .header-actions__cart-count, #cart-bubble-text');
    oldBubbles.forEach(el => {
      if (el.classList.contains('cart-icon-bubble')) {
        el.innerHTML = count > 0 ? `<span class="cart-icon-bubble__count" style="display:inline-block; min-width:18px; height:18px; line-height:18px; text-align:center; background:var(--color-champagne-gold, #C5A880); color:#fff; font-size:11px; font-weight:700; border-radius:50%;">${count}</span>` : '';
      } else if (!el.closest('.cart-bubble')) {
        el.textContent = count > 0 ? count : '';
      }
    });

    const headerIcon = document.querySelector('.header-actions__cart-icon, cart-icon-component');
    if (headerIcon) {
      headerIcon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    }
  }

  function openCartDrawer() {
    const dialog = document.querySelector('.cart-drawer__dialog');
    if (dialog) {
      const items = getLocalCart();
      if (items.length > 0) {
        dialog.classList.remove('cart-drawer--empty');
      }
      if (typeof dialog.showModal === 'function' && !dialog.open) {
        dialog.showModal();
      }
      dialog.classList.add('is-open');
    }
    const drawerComp = document.querySelector('cart-drawer-component');
    if (drawerComp && typeof drawerComp.open === 'function') {
      drawerComp.open();
    }
  }

  function closeCartDrawer() {
    const drawerComp = document.querySelector('cart-drawer-component');
    if (drawerComp && typeof drawerComp.close === 'function') {
      drawerComp.close();
      return;
    }
    const dialog = document.querySelector('.cart-drawer__dialog');
    if (dialog) {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
      }
      dialog.classList.remove('is-open');
    }
  }

  function renderPopulatedDrawer(items) {
    const inner = document.querySelector('.cart-drawer__inner');
    if (!inner) return;

    if (!items || items.length === 0) {
      inner.innerHTML = `
        <div class="cart-drawer__header" style="display:flex; justify-content:space-between; align-items:center; padding:1.25rem 1.5rem; border-bottom:1px solid rgba(36,28,24,0.08);">
          <h2 class="cart-drawer__heading h4" style="margin:0; font-family:var(--font-serif); font-size:1.35rem; color:var(--color-deep-espresso);">Votre panier est vide</h2>
          <button type="button" class="button close-button cart-drawer__close-button button-unstyled js-luxury-close" aria-label="Fermer" style="cursor:pointer; background:none; border:none; padding:4px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
          </button>
        </div>
        <div style="padding:3rem 1.5rem; text-align:center;">
          <p style="color:rgba(36,28,24,0.7); font-size:0.95rem; margin-bottom:1.5rem;">Découvrez notre rituel capillaire d'exception à la kératine végétale, vanille bourbon et monoï.</p>
          <a href="/collections/all" class="button" style="display:inline-block; background:var(--color-deep-espresso, #241C18); color:#fff; padding:14px 28px; font-size:0.85rem; font-weight:700; text-transform:uppercase; letter-spacing:0.12em; text-decoration:none;">Découvrir le Rituel</a>
        </div>
        <div style="margin-top:auto; padding:1.5rem; background:#faf7f2; border-top:1px solid rgba(36,28,24,0.08); text-align:center;">
          <div style="display:flex; justify-content:center; gap:16px; font-size:0.75rem; color:rgba(36,28,24,0.7); margin-bottom:10px;">
            <span>🔒 Paiement SSL Sécurisé</span>
            <span>↩ Retours sous 30 jours</span>
            <span>⚡ Expédition 24/48h</span>
          </div>
          <div class="payment-methods-list payment-methods-list--auto" style="display:flex; justify-content:center; gap:6px; flex-wrap:wrap; align-items:center;">
            ${PAYMENT_ICONS_SVG_HTML}
          </div>
        </div>
      `;
      updateHeaderCartBubble(0);
      return;
    }

    let totalCents = 0;
    let totalCount = 0;
    const hasShampoo = items.some(i => i.id === 48015124463754);
    const hasMask = items.some(i => i.id === 48015148744842);

    items.forEach(item => {
      totalCents += (item.price * item.quantity);
      totalCount += item.quantity;
    });

    const progressPct = Math.min(100, Math.round((totalCents / FREE_SHIPPING_THRESHOLD) * 100));
    let shippingText = '';
    if (totalCents >= FREE_SHIPPING_THRESHOLD) {
      shippingText = `✨ <strong>Livraison Offerte atteinte !</strong> Votre commande bénéficie de l'expédition gratuite.`;
    } else {
      const diff = formatMoney(FREE_SHIPPING_THRESHOLD - totalCents);
      shippingText = `Ajoutez encore <strong>${diff}</strong> pour bénéficier de la <strong>Livraison offerte</strong> en France & Europe.`;
    }

    let itemsHtml = items.map(item => {
      return `
        <div class="luxury-cart-line-item" data-variant-id="${item.id}" style="display:flex; gap:14px; padding:14px 0; border-bottom:1px solid rgba(36,28,24,0.08); align-items:center;">
          <a href="${item.url}" style="flex-shrink:0;">
            <img src="${item.image}" alt="${item.title}" style="width:72px; height:72px; object-fit:cover; border:1px solid rgba(36,28,24,0.1); border-radius:2px; display:block;" />
          </a>
          <div style="flex-grow:1; min-width:0;">
            <span style="font-size:0.65rem; letter-spacing:0.14em; text-transform:uppercase; color:var(--color-champagne-gold, #C5A880); font-weight:700; display:block; margin-bottom:2px;">${item.step || 'SOIN'}</span>
            <a href="${item.url}" style="text-decoration:none; color:var(--color-deep-espresso, #241C18); font-family:var(--font-serif); font-size:0.95rem; font-weight:600; line-height:1.25; display:block; margin-bottom:4px; overflow:hidden; text-overflow:ellipsis; white-space:nowrap;">${item.title}</a>
            <div style="font-family:var(--font-serif); font-size:0.95rem; color:var(--color-deep-espresso); font-weight:700;">${item.formattedPrice}</div>
          </div>
          <div style="display:flex; flex-direction:column; align-items:flex-end; gap:8px; flex-shrink:0;">
            <div style="display:flex; align-items:center; border:1px solid rgba(36,28,24,0.25); border-radius:2px; background:#fff;">
              <button type="button" class="js-luxury-qty-btn" data-variant-id="${item.id}" data-change="-1" style="width:26px; height:28px; border:none; background:transparent; cursor:pointer; font-size:1rem; line-height:1; display:flex; align-items:center; justify-content:center; color:#241C18;">−</button>
              <span style="font-size:0.85rem; font-weight:600; padding:0 8px; min-width:20px; text-align:center; color:#241C18;">${item.quantity}</span>
              <button type="button" class="js-luxury-qty-btn" data-variant-id="${item.id}" data-change="1" style="width:26px; height:28px; border:none; background:transparent; cursor:pointer; font-size:1rem; line-height:1; display:flex; align-items:center; justify-content:center; color:#241C18;">+</button>
            </div>
            <button type="button" class="js-luxury-remove-btn" data-variant-id="${item.id}" style="border:none; background:transparent; font-size:0.75rem; color:rgba(36,28,24,0.55); text-decoration:underline; cursor:pointer; padding:0;">Supprimer</button>
          </div>
        </div>
      `;
    }).join('');

    let crossSellHtml = '';
    if (hasShampoo && !hasMask) {
      crossSellHtml = `
        <div style="margin-top:1.25rem; background:var(--color-soft-vanilla, #FBF9F5); border:1px solid var(--color-border-gold, #C5A880); padding:12px 14px; border-radius:2px;">
          <div style="font-size:0.7rem; letter-spacing:0.12em; text-transform:uppercase; color:var(--color-champagne-gold, #C5A880); font-weight:700; margin-bottom:6px;">✨ Complétez votre Rituel (Étape 02)</div>
          <div style="display:flex; gap:12px; align-items:center;">
            <img src="//cdn.shopify.com/s/files/1/0726/9633/2426/files/IMG_1997.jpg?v=1776012426&width=200" style="width:50px; height:50px; object-fit:cover; border:1px solid rgba(36,28,24,0.1); flex-shrink:0;" />
            <div style="flex-grow:1; min-width:0;">
              <div style="font-family:var(--font-serif); font-size:0.85rem; font-weight:600; color:var(--color-deep-espresso); white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">Masque Capillaire Kératine</div>
              <div style="font-size:0.8rem; color:rgba(36,28,24,0.7); font-weight:600;">19,99 €</div>
            </div>
            <button type="button" class="js-luxury-cross-add" data-variant-id="48015148744842" style="background:var(--color-deep-espresso, #241C18); color:#fff; border:none; padding:8px 14px; font-size:0.75rem; font-weight:700; letter-spacing:0.08em; text-transform:uppercase; cursor:pointer; flex-shrink:0;">+ Ajouter</button>
          </div>
        </div>
      `;
    } else if (hasMask && !hasShampoo) {
      crossSellHtml = `
        <div style="margin-top:1.25rem; background:var(--color-soft-vanilla, #FBF9F5); border:1px solid var(--color-border-gold, #C5A880); padding:12px 14px; border-radius:2px;">
          <div style="font-size:0.7rem; letter-spacing:0.12em; text-transform:uppercase; color:var(--color-champagne-gold, #C5A880); font-weight:700; margin-bottom:6px;">✨ Complétez votre Rituel (Étape 01)</div>
          <div style="display:flex; gap:12px; align-items:center;">
            <img src="//cdn.shopify.com/s/files/1/0726/9633/2426/files/e58f5f15-6c8c-478e-b1c1-28ae26ad79e6_591d135e-7728-4695-86ca-02bf8b3b3255.jpg?v=1776013540&width=200" style="width:50px; height:50px; object-fit:cover; border:1px solid rgba(36,28,24,0.1); flex-shrink:0;" />
            <div style="flex-grow:1; min-width:0;">
              <div style="font-family:var(--font-serif); font-size:0.85rem; font-weight:600; color:var(--color-deep-espresso); white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">Shampoing Kératine & Monoï</div>
              <div style="font-size:0.8rem; color:rgba(36,28,24,0.7); font-weight:600;">19,99 €</div>
            </div>
            <button type="button" class="js-luxury-cross-add" data-variant-id="48015124463754" style="background:var(--color-deep-espresso, #241C18); color:#fff; border:none; padding:8px 14px; font-size:0.75rem; font-weight:700; letter-spacing:0.08em; text-transform:uppercase; cursor:pointer; flex-shrink:0;">+ Ajouter</button>
          </div>
        </div>
      `;
    } else if (hasShampoo && hasMask) {
      crossSellHtml = `
        <div style="margin-top:1.25rem; background:#fbf8f3; border:1px dashed var(--color-border-gold, #C5A880); padding:12px; text-align:center; border-radius:2px;">
          <span style="font-size:0.8rem; font-weight:700; color:var(--color-deep-espresso);">🌿 Rituel Kératine Signature sélectionné</span>
          <div style="font-size:0.75rem; color:rgba(36,28,24,0.65); margin-top:2px;">Synergie active : Nettoyage doux + Nutrition profonde</div>
        </div>
      `;
    }

    inner.innerHTML = `
      <div class="cart-drawer__header" style="display:flex; justify-content:space-between; align-items:center; padding:1.25rem 1.5rem; border-bottom:1px solid rgba(36,28,24,0.08); background:#fff;">
        <h2 class="cart-drawer__heading h4" style="margin:0; font-family:var(--font-serif); font-size:1.35rem; color:var(--color-deep-espresso); display:flex; align-items:center;">
          Mon Panier <span style="font-family:var(--font-sans); font-size:0.85rem; font-weight:700; background:var(--color-champagne-gold, #C5A880); color:#fff; padding:2px 8px; border-radius:12px; margin-left:8px;">${totalCount}</span>
        </h2>
        <button type="button" class="button close-button cart-drawer__close-button button-unstyled js-luxury-close" aria-label="Fermer" style="cursor:pointer; background:none; border:none; padding:4px;">
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </button>
      </div>

      <!-- FREE SHIPPING PROGRESS BAR -->
      <div style="background:var(--color-soft-vanilla, #FBF9F5); padding:12px 1.5rem; border-bottom:1px solid rgba(36,28,24,0.08);">
        <div style="font-family:var(--font-sans); font-size:0.825rem; color:var(--color-deep-espresso); margin-bottom:8px;">
          ${shippingText}
        </div>
        <div style="width:100%; height:5px; background:rgba(36,28,24,0.1); border-radius:3px; overflow:hidden;">
          <div style="width:${progressPct}%; height:100%; background:var(--color-champagne-gold, #C5A880); transition:width 0.4s ease;"></div>
        </div>
      </div>

      <!-- SCROLLABLE CONTENT -->
      <div class="cart-drawer__content" style="padding:0.75rem 1.5rem 1.5rem; overflow-y:auto; flex-grow:1; max-height:calc(100vh - 310px);">
        <div class="luxury-cart-items-container">
          ${itemsHtml}
        </div>
        ${crossSellHtml}
      </div>

      <!-- FOOTER SUMMARY & CHECKOUT -->
      <div style="padding:1.25rem 1.5rem; background:#fff; border-top:1px solid rgba(36,28,24,0.08); margin-top:auto;">
        <div style="display:flex; justify-content:space-between; align-items:baseline; margin-bottom:0.4rem;">
          <span style="font-family:var(--font-sans); font-size:0.9rem; text-transform:uppercase; letter-spacing:0.05em; font-weight:600; color:var(--color-deep-espresso);">Sous-total</span>
          <span style="font-family:var(--font-serif); font-size:1.4rem; font-weight:700; color:var(--color-deep-espresso);">${formatMoney(totalCents)}</span>
        </div>
        <div id="js-luxury-checkout-error" style="display:none; background:#fff8e6; color:#78490a; border:1px solid #f6d48b; padding:12px 14px; font-size:0.775rem; border-radius:3px; margin-bottom:12px; text-align:left; line-height:1.45;"></div>

        <button type="button" class="button js-luxury-checkout-btn" style="display:block; width:100%; text-align:center; background:var(--color-deep-espresso, #241C18); color:#fff; padding:16px 20px; font-family:var(--font-sans); font-weight:700; font-size:0.85rem; letter-spacing:0.12em; text-transform:uppercase; text-decoration:none; border:none; border-radius:0; box-shadow:0 4px 14px rgba(36,28,24,0.15); transition:all 0.3s ease; cursor:pointer;">
          COMMANDER • ${formatMoney(totalCents)}
        </button>

        <!-- TRUST BADGES -->
        <div style="margin-top:1rem; padding-top:0.75rem; border-top:1px solid rgba(36,28,24,0.06); text-align:center;">
          <div style="display:flex; justify-content:center; gap:14px; font-size:0.725rem; color:rgba(36,28,24,0.7); margin-bottom:8px;">
            <span>🔒 SSL Sécurisé</span>
            <span>↩ Retours sous 30 jours</span>
            <span>⚡ Expédition 24/48h</span>
          </div>
          <div class="payment-methods-list payment-methods-list--auto" style="display:flex; justify-content:center; gap:6px; flex-wrap:wrap; align-items:center;">
            ${PAYMENT_ICONS_SVG_HTML}
          </div>
        </div>
      </div>
    `;

    updateHeaderCartBubble(totalCount);
  }

  function addLocalItem(variantId, quantity = 1) {
    variantId = Number(variantId);
    quantity = Number(quantity) || 1;
    const itemData = LUXURY_CATALOG[variantId];
    if (!itemData) return;

    let cart = getLocalCart();
    const existingIndex = cart.findIndex(i => i.id === variantId);
    if (existingIndex > -1) {
      cart[existingIndex].quantity += quantity;
    } else {
      cart.push({
        id: itemData.id,
        title: itemData.title,
        price: itemData.price,
        formattedPrice: itemData.formattedPrice,
        image: itemData.image,
        url: itemData.url,
        step: itemData.step,
        quantity: quantity
      });
    }

    saveLocalCart(cart);
    renderPopulatedDrawer(cart);
    openCartDrawer();
  }

  async function updateLocalQuantity(variantId, change) {
    variantId = Number(variantId);
    change = Number(change);
    let cart = getLocalCart();
    const existingIndex = cart.findIndex(i => i.id === variantId);
    if (existingIndex > -1) {
      const newQty = cart[existingIndex].quantity + change;
      if (newQty <= 0) {
        cart.splice(existingIndex, 1);
      } else {
        cart[existingIndex].quantity = newQty;
      }
      saveLocalCart(cart);
      renderPopulatedDrawer(cart);

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: Math.max(0, newQty) })
        });
      } catch (e) {}
    }
  }

  async function removeLocalItem(variantId) {
    variantId = Number(variantId);
    let cart = getLocalCart();
    cart = cart.filter(i => i.id !== variantId);
    saveLocalCart(cart);
    renderPopulatedDrawer(cart);

    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: String(variantId), quantity: 0 })
      });
    } catch (e) {}
  }

  async function handleCheckoutClick(btn) {
    if (!btn) return;
    const origHtml = btn.innerHTML;
    btn.disabled = true;
    btn.innerHTML = 'Préparation de la commande...';
    btn.style.opacity = '0.75';

    const errBox = document.getElementById('js-luxury-checkout-error');
    if (errBox) {
      errBox.style.display = 'none';
      errBox.innerHTML = '';
    }

    try {
      // 1. Check live server cart
      let cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      let cartData = cartRes.ok ? await cartRes.json() : null;

      // 2. If server cart is empty, try to sync local items to /cart/add.js
      if (!cartData || !Array.isArray(cartData.items) || cartData.items.length === 0) {
        const localItems = getLocalCart();
        if (localItems.length > 0) {
          for (const item of localItems) {
            const addRes = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: Number(item.id), quantity: Number(item.quantity) || 1 })
            });

            if (!addRes.ok) {
              const err = await addRes.json().catch(() => ({}));
              const msg = err.description || err.message || "Le produit n'est plus en stock.";
              if (errBox) {
                errBox.innerHTML = `<strong>⚠️ Impossible de finaliser la commande :</strong><br>${msg}<br><span style="margin-top:6px; display:block; font-size:0.75rem; color:#614300;">👉 <strong>Pour activer les commandes :</strong> Dans votre interface <em>Shopify Admin &gt; Produits &gt; Inventaire</em>, cochez la case <em>"Continuer à vendre en cas de rupture de stock"</em> (ou augmentez la quantité en stock disponible).</span>`;
                errBox.style.display = 'block';
              }
              btn.innerHTML = origHtml;
              btn.disabled = false;
              btn.style.opacity = '1';
              return;
            }
          }
          // Re-fetch updated cart
          cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
          cartData = cartRes.ok ? await cartRes.json() : null;
        }
      }

      if (cartData && Array.isArray(cartData.items) && cartData.items.length > 0) {
        btn.innerHTML = 'Redirection vers le paiement...';
        window.location.href = '/checkout';
      } else {
        if (errBox) {
          errBox.innerHTML = `<strong>⚠️ Votre panier est vide.</strong><br>Veuillez ajouter un produit au panier pour commander.`;
          errBox.style.display = 'block';
        }
        btn.innerHTML = origHtml;
        btn.disabled = false;
        btn.style.opacity = '1';
      }
    } catch (e) {
      console.warn('Checkout navigation fallback:', e);
      window.location.href = '/checkout';
    }
  }

  // Unified global Add To Cart function
  window.luxuryAddToCart = async function(variantId, quantity = 1, btn = null) {
    if (!variantId) return false;
    variantId = Number(variantId);
    quantity = Number(quantity) || 1;

    let origHtml = '';
    if (btn) {
      origHtml = btn.innerHTML;
      btn.innerHTML = 'Ajout en cours...';
      btn.disabled = true;
    }

    // Hide any error alerts immediately
    const errText = document.querySelector('.product-form-text__error, .cart-item__error');
    if (errText) errText.classList.add('hidden');

    try {
      // 1. Attempt server add
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });

      // 2. Fetch authoritative updated cart from Shopify /cart.js
      let syncedWithServer = false;
      try {
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const cartData = await cartRes.json();
          if (cartData && Array.isArray(cartData.items) && cartData.items.length > 0) {
            const items = cartData.items.map(item => {
              const catItem = LUXURY_CATALOG[item.variant_id] || LUXURY_CATALOG[item.id] || {};
              return {
                id: item.variant_id || item.id,
                title: item.product_title || item.title || catItem.title || 'Rituel Capillaire',
                price: item.price,
                formattedPrice: formatMoney(item.price),
                image: item.image || catItem.image || '//cdn.shopify.com/s/files/1/0726/9633/2426/files/IMG_3704.jpg?v=1776651141',
                url: item.url || catItem.url || '/products/duo-shampoing-masque',
                step: catItem.step || 'SOIN SIGNATURE',
                quantity: item.quantity
              };
            });
            saveLocalCart(items);
            renderPopulatedDrawer(items);
            openCartDrawer();
            syncedWithServer = true;
          }
        }
      } catch (err) {
        console.warn('Live cart fetch error', err);
      }

      // 3. If server cart did not sync (e.g. inventory tracking was 0 in Shopify Admin), use local fallback
      if (!syncedWithServer) {
        addLocalItem(variantId, quantity);
      }

      if (btn) {
        btn.innerHTML = 'Ajouté ✓';
        setTimeout(() => {
          btn.innerHTML = origHtml;
          btn.disabled = false;
        }, 1800);
      }
      return true;
    } catch (e) {
      console.warn('Network fallback triggered', e);
      addLocalItem(variantId, quantity);
      if (btn) {
        btn.innerHTML = 'Ajouté ✓';
        setTimeout(() => {
          btn.innerHTML = origHtml;
          btn.disabled = false;
        }, 1800);
      }
      return true;
    }
  };

  // Unified global Add Bundle To Cart function (supports multi-item payloads in 1 single request)
  window.luxuryAddBundleToCart = async function(items, btn = null) {
    if (!items || !items.length) return false;

    let origHtml = '';
    if (btn) {
      origHtml = btn.innerHTML;
      btn.innerHTML = 'Ajout en cours...';
      btn.disabled = true;
    }

    try {
      // 1. Post all items to /cart/add.js in a single request
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      });

      // 2. Fetch authoritative updated cart from Shopify /cart.js
      let syncedWithServer = false;
      try {
        const cartRes = await fetch('/cart.js');
        if (cartRes.ok) {
          const cartData = await cartRes.json();
          if (cartData && Array.isArray(cartData.items) && cartData.items.length > 0) {
            const mappedItems = cartData.items.map(item => {
              const catItem = LUXURY_CATALOG[item.variant_id] || LUXURY_CATALOG[item.id] || {};
              return {
                id: item.variant_id || item.id,
                title: item.product_title || item.title || catItem.title || 'Rituel Capillaire',
                price: item.price,
                formattedPrice: formatMoney(item.price),
                image: item.image || catItem.image || '//cdn.shopify.com/s/files/1/0726/9633/2426/files/IMG_3704.jpg?v=1776651141',
                url: item.url || catItem.url || '/products/duo-shampoing-masque',
                step: catItem.step || 'SOIN SIGNATURE',
                quantity: item.quantity
              };
            });
            saveLocalCart(mappedItems);
            renderPopulatedDrawer(mappedItems);
            openCartDrawer();
            syncedWithServer = true;
          }
        }
      } catch (err) {
        console.warn('Live cart fetch error', err);
      }

      if (!syncedWithServer) {
        items.forEach(it => {
          addLocalItem(it.id, it.quantity || 1);
        });
      }

      if (btn) {
        btn.innerHTML = 'Ajouté ✓';
        setTimeout(() => {
          btn.innerHTML = origHtml;
          btn.disabled = false;
        }, 1800);
      }
      return true;
    } catch (e) {
      console.warn('Bundle add error fallback', e);
      items.forEach(it => {
        addLocalItem(it.id, it.quantity || 1);
      });
      if (btn) {
        btn.innerHTML = 'Ajouté ✓';
        setTimeout(() => {
          btn.innerHTML = origHtml;
          btn.disabled = false;
        }, 1800);
      }
      return true;
    }
  };

  // Click delegation
  document.addEventListener('click', function(e) {
    // Any click inside drawer (except close button) should not bubble to outside backdrop
    const insideDrawer = e.target.closest('.cart-drawer__dialog, .cart-drawer__inner');
    const isClose = e.target.closest('.js-luxury-close, .close-button, [aria-label*="Fermer"], [aria-label*="Close"]');

    // Close button
    if (isClose) {
      e.preventDefault();
      e.stopPropagation();
      closeCartDrawer();
      return;
    }

    // Quantity buttons inside drawer
    const qtyBtn = e.target.closest('.js-luxury-qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const vId = qtyBtn.getAttribute('data-variant-id');
      const change = qtyBtn.getAttribute('data-change');
      updateLocalQuantity(vId, change);
      return;
    }

    // Remove button inside drawer
    const remBtn = e.target.closest('.js-luxury-remove-btn');
    if (remBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const vId = remBtn.getAttribute('data-variant-id');
      removeLocalItem(vId);
      return;
    }

    // Cross-sell add inside drawer
    const crossBtn = e.target.closest('.js-luxury-cross-add');
    if (crossBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      const vId = crossBtn.getAttribute('data-variant-id');
      if (window.luxuryAddToCart) {
        window.luxuryAddToCart(vId, 1, crossBtn);
      } else {
        addLocalItem(vId, 1);
      }
      return;
    }

    // Checkout button inside drawer
    const checkoutBtn = e.target.closest('.js-luxury-checkout-btn, a[href="/checkout"], [data-action="checkout"]');
    if (checkoutBtn) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      handleCheckoutClick(checkoutBtn);
      return;
    }

    if (insideDrawer) {
      e.stopPropagation();
    }

    // Header cart bag icon click
    const headerCart = e.target.closest('[data-testid="cart-drawer-trigger"], .action__cart, .header-actions__cart-icon');
    if (headerCart) {
      const cart = getLocalCart();
      if (cart.length > 0) {
        e.preventDefault();
        renderPopulatedDrawer(cart);
        openCartDrawer();
        return;
      }
    }

    // Main Add to Cart buttons — simple, no bundles
    const atcBtn = e.target.closest('.luxury-btn-gold, .js-ajax-add, .js-drawer-upsell-btn, button[name="add"], .add-to-cart-button, [data-testid="standalone-add-to-cart"], form[action*="/cart/add"] button[type="submit"]');
    if (atcBtn) {
      e.preventDefault();
      e.stopPropagation();

      const form = atcBtn.closest('form');
      // Read variant ID from: data attribute, form input, or active chip
      const vId = atcBtn.getAttribute('data-variant-id')
        || form?.querySelector('[name="id"]')?.value
        || null;
      const qty = Number(atcBtn.getAttribute('data-quantity'))
        || Number(form?.querySelector('[name="quantity"]')?.value)
        || 1;

      if (vId) {
        window.luxuryAddToCart(vId, qty, atcBtn);
        return;
      }
    }
  }, true);

  // Form submit interception — simple, no bundles
  document.addEventListener('submit', function(e) {
    const form = e.target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
    if (form) {
      e.preventDefault();
      e.stopPropagation();
      const btn = form.querySelector('button[name="add"], .add-to-cart-button, button[type="submit"]');
      const vId = form.querySelector('[name="id"]')?.value || null;
      const qty = Number(form.querySelector('[name="quantity"]')?.value) || 1;
      if (vId) {
        window.luxuryAddToCart(vId, qty, btn);
      }
      return false;
    }
  }, true);

  // On page load, sync with live /cart.js and local cart state
  document.addEventListener('DOMContentLoaded', async function() {
    // Fast render from local cache if present
    const localCart = getLocalCart();
    if (localCart.length > 0) {
      let totalCount = 0;
      localCart.forEach(i => totalCount += i.quantity);
      updateHeaderCartBubble(totalCount);
      renderPopulatedDrawer(localCart);
    }

    // Live sync with Shopify /cart.js
    try {
      const res = await fetch('/cart.js');
      if (res.ok) {
        const cartData = await res.json();
        if (cartData && Array.isArray(cartData.items) && cartData.items.length > 0) {
          const items = cartData.items.map(item => {
            const catItem = LUXURY_CATALOG[item.variant_id] || LUXURY_CATALOG[item.id] || {};
            return {
              id: item.variant_id || item.id,
              title: item.product_title || item.title || catItem.title || 'Rituel Capillaire',
              price: item.price,
              formattedPrice: formatMoney(item.price),
              image: item.image || catItem.image || '//cdn.shopify.com/s/files/1/0726/9633/2426/files/IMG_3704.jpg?v=1776651141',
              url: item.url || catItem.url || '/products/duo-shampoing-masque',
              step: catItem.step || 'SOIN SIGNATURE',
              quantity: item.quantity
            };
          });
          saveLocalCart(items);
          renderPopulatedDrawer(items);
        } else if (cartData && Array.isArray(cartData.items) && cartData.items.length === 0 && localCart.length === 0) {
          updateHeaderCartBubble(0);
        }
      }
    } catch (e) {}
  });

  /* ═════════════════════════════════════════════════════════════════════
     PRODUCT MEDIA GALLERY VIDEO PLAYBACK ENGINE (MOBILE & DESKTOP)
     Guarantees that product gallery videos play seamlessly on mobile,
     unpacks deferred-media directly over the slide without layout shifts,
     and provides instant tap-to-play and autoplay when slide 4 is in view.
     ═════════════════════════════════════════════════════════════════════ */
  function initProductGalleryVideoEngine() {
    const deferredMedias = document.querySelectorAll('.product-information__media deferred-media, media-gallery deferred-media');
    if (!deferredMedias.length) return;

    deferredMedias.forEach(dm => {
      const slide = dm.closest('.slideshow-slide, .product-media-container');
      const posterBtn = dm.querySelector('.deferred-media__poster-button');

      function startPlayback(focus = false) {
        if (!dm.hasAttribute('data-media-loaded')) {
          if (typeof dm.showDeferredMedia === 'function') {
            dm.showDeferredMedia();
          } else if (typeof dm.loadContent === 'function') {
            dm.loadContent(focus);
          } else {
            const tpl = dm.querySelector('template');
            if (tpl) {
              const node = tpl.content.firstElementChild?.cloneNode(true);
              if (node) {
                dm.setAttribute('data-media-loaded', 'true');
                dm.appendChild(node);
              }
            }
          }
        }

        const video = dm.querySelector('video');
        if (video) {
          video.setAttribute('playsinline', '');
          video.setAttribute('webkit-playsinline', '');
          video.playsInline = true;
          video.muted = true;
          video.style.objectFit = 'cover';
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise.catch(() => {
              // Mobile browser policy fallback: mute and retry
              video.muted = true;
              video.play().catch(() => {});
            });
          }
        }
      }

      // Tap / Click on poster button or slide
      if (posterBtn) {
        posterBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          startPlayback(true);
        });
      }

      // Slide click fallback
      if (slide) {
        slide.addEventListener('click', function(e) {
          if (!dm.hasAttribute('data-media-loaded')) {
            startPlayback(true);
          }
        });
      }

      // Video toggle click once playing
      dm.addEventListener('click', function(e) {
        const video = dm.querySelector('video');
        if (video && e.target === video) {
          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        }
      });

      // Autoplay on slide visibility (IntersectionObserver)
      if (slide && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.4) {
              startPlayback(false);
            } else if (!entry.isIntersecting) {
              const video = dm.querySelector('video');
              if (video && !video.paused) {
                video.pause();
              }
            }
          });
        }, { threshold: [0.2, 0.4, 0.8] });

        observer.observe(slide);
      }
    });

    // Also observe thumbnail clicks for immediate video trigger
    const thumbnails = document.querySelectorAll('slideshow-controls button, .slideshow-control, [data-thumbnail-index]');
    thumbnails.forEach(thumb => {
      thumb.addEventListener('click', function() {
        setTimeout(() => {
          const activeSlide = document.querySelector('.slideshow-slide[active], .slideshow-slide.is-selected, .slideshow-slide[aria-hidden="false"]');
          const dm = activeSlide?.querySelector('deferred-media');
          if (dm) {
            if (!dm.hasAttribute('data-media-loaded')) {
              if (typeof dm.showDeferredMedia === 'function') dm.showDeferredMedia();
              else if (typeof dm.loadContent === 'function') dm.loadContent(false);
            }
            const v = dm.querySelector('video');
            if (v) {
              v.muted = true;
              v.playsInline = true;
              v.play().catch(() => {});
            }
          }
        }, 150);
      });
    });
  }

  // Initialize on load and on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductGalleryVideoEngine);
  } else {
    initProductGalleryVideoEngine();
  }

})();
